<template>
  <!-- <NavBar /> -->
  <div class="app-container" :class="{'safe-top': calcStatusBarHeight}">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-if="hasInit && $route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="hasInit && !$route.meta.keepAlive" />
    </router-view>
  </div>
</template>
<script>
// import NavBar from '@/components/NavBar.vue';
import { mapState, mapActions, mapMutations } from 'vuex'
import { biInit } from '@/api/bi'
import ETC from '@/config/etc'
import { getStatusBarHeight } from '@/utils/common'
import qs from 'qs'
export default {
  data() {
    return {
      hasInit: false,
      templateContent: {}
    }
  },
  components: {
    // NavBar
  },
  computed: mapState(['entryInfo', 'calcStatusBarHeight']),
  methods: {
    ...mapActions(['appInit', 'uploadEntryInfo']),
    ...mapMutations(['setToken', 'setEntryInfo', 'setCalcStatusBarHeight']),
    handleParams(params) {
      let applyInfo = JSON.parse(localStorage.getItem('applyInfo'))
      this.setEntryInfo({
        ...params,
        bd_vid: params?.bd_vid || '',
        pl: params?.pl || this.entryInfo.pl || applyInfo?.pl || 1257,
        entry: params?.entry || params?.entry_id || 1000,
        bizExt: params?.bizExt || '',
        url: location.href,
        hasUpload: false
      })
      localStorage.setItem('applyInfo', JSON.stringify({
        ...applyInfo,
        ...params,
      }))
      if (params?.pageSn) {
        console.log(123132, location.href);
        switch (true) {
          case location.href.indexOf('/third/bank') >= 0:
            localStorage.setItem(ETC.SESSION_STORAGE_KEY.BANK_PAGESN, params.pageSn)
            break;
          case location.href.indexOf('/enterprise/prodDetail') >= 0:
            localStorage.setItem(ETC.SESSION_STORAGE_KEY.ENTERPRISE_PAGESN, params.pageSn)
            break;
          case location.href.indexOf('/third/coupon') >= 0:
            localStorage.setItem(ETC.SESSION_STORAGE_KEY.COUPON_PAGESN, params.pageSn)
            break;
          default:
            break;
        }
      }
      this.uploadEntryInfo()
    }
  },
  async created() {
    const query = qs.parse(location.search.substring(1))
    console.log('beforeCreate query ==>', query)
    this.handleParams(query)
    const channel = query.channel || localStorage.getItem(ETC.LOCAL_STORAGE_KEY.CHANNEL) || ''
    if (channel) {
      // 渠道信息初始化
      // const showStatusBarChannel = []
      // if (showStatusBarChannel.includes(query.channel)) {
      //   this.setCalcStatusBarHeight(true)
      // }
      const token = query.token || localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN) || ''
      this.setToken(token)
      console.log('渠道信息初始化 ==>', query.channel)
      await this.appInit({
        channel: channel,
        token: token
      })
    }
    if (query.redirect) {
      this.$router.replace(query.redirect)
    }
    this.hasInit = true
    biInit()
  }
}
</script>
<style lang="less">
html, body {
  height: 100%;
}
// .van-nav-bar {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100;
//   .van-icon {
//     color: #666;
//   }
// }
#app {
  height: 100%;
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 28px;
  line-height: 40px;
  .app-container {
    height: 100%;
    box-sizing: border-box;
    &.safe-top {
      padding-top: 40px;
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
    }
  }
}



</style>
